import isNaN from 'lodash/isNaN'
import toNumber from 'lodash/toNumber'
/**
 * This will unFlatten the object. The opposite of flatten
 * All fields should be in flatten format, array in dot notation (just like the mongodb)
 * from { "a.b": 1, "a.c": 2 } to { a: { b: 1, c: 2 } }
 * @param obj -  the flatten object
 */
export function unFlattenObject(obj: Record<string, unknown>) {
  const result = {}

  for (const key in obj) {
    const value = obj[key]
    const keys = key.split('.')

    let currentObject = result
    for (let i = 0; i < keys.length - 1; i++) {
      const nestedKey = keys[i]
      if (!currentObject[nestedKey]) {
        // Check if the next key is an array index
        const nextKeyIsArrayIndex = !isNaN(toNumber(keys[i + 1]))
        currentObject[nestedKey] = nextKeyIsArrayIndex ? [] : {}
      }
      currentObject = currentObject[nestedKey]
    }

    const lastKey = keys[keys.length - 1]
    currentObject[lastKey] = value
  }

  return result
}
